import { Link, useParams } from 'react-router-dom';
import { Forklift } from 'lucide-react';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { isEquipmentCategory } from '@/features/equipment/model';
import { EquipmentPage } from '@/pages/catalog/EquipmentPage';

/**
 * `/catalog/equipment/category/:category` — the equipment grid scoped
 * to one of the four fixed categories. Keyed on the category so
 * switching between sidebar rows resets the grid's local state.
 */
export function EquipmentCategoryPage() {
  const { category } = useParams<{ category: string }>();

  if (!isEquipmentCategory(category)) {
    return (
      <div className="space-y-6">
        <PageHeader title="Equipment" />
        <Card>
          <CardContent className="pt-6">
            <EmptyState
              icon={Forklift}
              title="That equipment category doesn't exist"
              action={
                <Button asChild variant="outline">
                  <Link to="/catalog/equipment">All equipment</Link>
                </Button>
              }
            />
          </CardContent>
        </Card>
      </div>
    );
  }

  return <EquipmentPage key={category} category={category} />;
}
